import { createSlice } from '@reduxjs/toolkit';

const clientsSlice = createSlice({
  name: 'clients',
  initialState: { 'userId': null },
  reducers: {
    setClients(state, action) {
      const userId = localStorage.getItem('user_id')
      const client = action.payload

      if (!userId) {
        console.warn('User id not in local storage')
        return
      }

      const userIDString = userId.toString()
      // An empty object is a valid, successfully loaded result for a new user.
      // Keeping the user key lets consumers distinguish "loaded with no clients"
      // from the initial state, which only contains the userId metadata field.
      state[userIDString] = client
      state['userId'] = userIDString
    },
    addClient(state, action) {
      const userId = localStorage.getItem('user_id');
      const client = action.payload;

      if (!userId) {
        console.warn('User ID not in local storage');
        return;
      }

      if (Object.keys(client).length === 0) {
        console.warn('Client object is empty');
        return;
      }

      const userIDString = userId.toString();

      // If userId already exists in state, add the client to the user's clients
      state[userIDString] = {
        ...state[userIDString],
        [client.client_id]: client  // Add new client with client_id as key
      };

      state['userId'] = userIDString;  // Update the userId reference in state
    },
    updateClient(state, action) {
      console.log("Action Payload:", action.payload); // Log the action payload
      
      const userId = localStorage.getItem('user_id');
      const { clientId, proposalItemId, proposal } = action.payload;
    
      if (!userId) {
        console.warn('User ID not found in local storage.');
        return;
      }
    
      if (!state[userId] || !state[userId][clientId]) {
        console.warn(`Client ID ${clientId} not found for user ID ${userId}.`);
        return;
      }
    
      const clientProposals = state[userId][clientId].proposals;
    
      if (!Array.isArray(clientProposals)) {
        console.warn(`Proposals array not found for client ID ${clientId}.`);
        return;
      }
    
      // Find the index of the proposal to update
      const proposalIndex = clientProposals.findIndex(
        (item) => item.id === proposalItemId
      );
    
      if (proposalIndex === -1) {
        console.warn(`Proposal with ID ${proposalItemId} not found.`);
        return;
      }
    
      // Replace the proposal with the new proposal object
      clientProposals[proposalIndex] = { ...proposal };
      
      console.log(`Proposal with ID ${proposalItemId} updated successfully.`, clientProposals[proposalIndex]);
    },    
    updateProposalInfo(state, action) {
      const userId = localStorage.getItem('user_id');
      if (!userId) {
        console.warn('User id not in local storage');
        return;
      }
      const { clientID, formData, grantProposalForm_id } = action.payload;

      // Function to deep clone and serialize the formData
      const serializeFormData = (data) => {
        return JSON.parse(JSON.stringify(data, (key, value) => {
          if (value instanceof Date) {
            return value.toISOString(); // Convert Date to ISO string
          }
          return value;
        }));
      };

      const serializedFormData = serializeFormData(formData);

      const proposalWithId = {
        ...serializedFormData,
        id: grantProposalForm_id
      };

      // Check if the state contains the clientId for the current user
      if (state[userId] && state[userId][clientID]) {
        // Append the proposal to the proposals array
        if (!state[userId][clientID].proposals) {
          state[userId][clientID].proposals = [];
        }
        state[userId][clientID].proposals.push(proposalWithId);
      } else {
        throw new Error(`Client ID ${clientID} not found for user ID ${userId}`);
      }
    },
    logoutClients(state) {
      return { userId: null }; // Reset to initial state for clients
    },
  },
});

export const { setClients, addClient, updateClient, updateProposalInfo, logoutClients } = clientsSlice.actions;
export default clientsSlice.reducer;
